<mat-card>
  <mat-toolbar-row>
    <h3>{{ 'SSH Connections' | translate }}</h3>

    <div class="actions action-icon">
      <button
        *ixRequiresRoles="requiredRoles"
        mat-button
        color="default"
        [ixTest]="['add-ssh-connection']"
        (click)="doAdd()"
      >
        {{ 'Add' | translate }}
      </button>
    </div>
  </mat-toolbar-row>
  <mat-card-content>
    <ix-table2
      [ix-table2-empty]="!(dataProvider.currentPageCount$ | async)"
      [emptyConfig]="emptyService.defaultEmptyConfig(dataProvider.emptyType$ | async)"
    >
      <thead
        ix-table-head
        [columns]="columns"
        [dataProvider]="dataProvider"
      ></thead>
      <tbody
        ix-table-body
        [columns]="columns"
        [dataProvider]="dataProvider"
        [isLoading]="dataProvider.isLoading$ | async"
      ></tbody>
    </ix-table2>
    <ix-table-pager-show-more [pageSize]="5" [dataProvider]="dataProvider"></ix-table-pager-show-more>
  </mat-card-content>
</mat-card>
